module.exports = __webpack_public_path__ + "img/exam-1.48a0a9ac.png";